<template>
  <div class="oneui">
    <div>
      <ul class="nameWrapper" :style="`grid-template-columns: 1fr;`">
        <li></li>
        <li class="current">
          <span>{{$t('pages.settings.account')}}</span>
        </li>
        <li></li>
      </ul>
    </div>
    <div class="pageWrapper">
      <div class="page">
        <div class="ul">
          <div class="li">
            <span>
              <center>Email: {{$root.$data.parent.get('user').get('email')}}</center>
            </span>
          </div>
          <SettingsButton path="/settings/account/changePin" text="pages.settings.resetPIN" />
          <!-- <SettingsButton path="/handlePatreon" text="pages.settings.linkPatreon" /> -->
          <!-- <SettingsButton text="pages.settings.changePassword" /> -->
          <SettingsButton path="/logout" text="pages.settings.logout" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SettingsButton from "../../components/SettingButton";
export default {
  name: "SettingsAccount",
  components: {
    SettingsButton
  }
};
</script>